import { type RefObject } from 'react';

import CameraControlsOverlay from '@cartwhl/ui/player/CameraControlsOverlay';

import { usePlayerCameraControls } from '../hooks/usePlayerCameraControls';
import type { PlayerCameraControlsHandle } from '../types';

export interface PlayerCameraControlsOverlayProps {
  cameraControlsRef?: RefObject<PlayerCameraControlsHandle | null>;
}

export default function PlayerCameraControlsOverlay({
  cameraControlsRef,
}: PlayerCameraControlsOverlayProps) {
  const {
    hasCameraControls,
    inputMode,
    setInputMode,
    follow,
    setFollow,
    zoomIn,
    zoomOut,
    frame,
  } = usePlayerCameraControls({ cameraControlsRef });

  return (
    <CameraControlsOverlay
      disabled={!hasCameraControls}
      follow={follow}
      frameCharacter={frame}
      inputMode={inputMode}
      setFollow={setFollow}
      setInputMode={setInputMode}
      zoomIn={zoomIn}
      zoomOut={zoomOut}
    />
  );
}

PlayerCameraControlsOverlay.overlayPlacement = 'bottom-left';
